// extracted by mini-css-extract-plugin
export default {"status":"E2Ip7k","body":"n38qqd","spinner":"E2_siX","title":"eE7hVh","colorGreen":"wgoeIA","description":"IlOY15"};